export default function() {
	new Swiper('.feature-swiper', {
		slidesPerView: 3,
		slidesPerGroup: 1,
		spaceBetween: 36,
		navigation: {
			nextEl: '.feature-nav._next',
			prevEl: '.feature-nav._prev',
		},
		breakpoints: {
			991: {
				slidesPerView: 2
			},
			767: {
				slidesPerView: 1
			}

		}
	})

	function CountDown() {
		let eventTime = moment('26-11-2019 10:00:00', 'DD-MM-YYYY HH:mm:ss').unix();	
		let currentTime = moment().unix();
		let diffTime = eventTime - currentTime;
		let duration = moment.duration(diffTime * 1000, 'milliseconds');
		let interval = 1000;
		
		let $d = $('#d');
		let $h = $('#h');
		let $m = $('#m');
		let $s = $('#s');
		if(duration <= 0) {
			$('.count-down').addClass('done');	
        	$('.home-banner-section').addClass('count-down-done');
        	return;
		}
		setInterval(function(){

            duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
            if(duration <= 0) {
        		
            }
            var d = moment.duration(duration).days(),
                h = moment.duration(duration).hours(),
                m = moment.duration(duration).minutes(),
                s = moment.duration(duration).seconds();

            d = $.trim(d).length === 1 ? '0' + d : d;
            h = $.trim(h).length === 1 ? '0' + h : h;
            m = $.trim(m).length === 1 ? '0' + m : m;
            s = $.trim(s).length === 1 ? '0' + s : s;

            // show how many hours, minutes and seconds are left
            $d.text(d);
            $h.text(h);
            $m.text(m);
            $s.text(s);

        }, interval);
	}

	CountDown();

	function BannerVideo() {
		let $videoWrapper = $('#banner-video-wrapper');
		let $video = $('#banner-video');
		let $playBtn = $('#banner-video-play');

		let src = $video.attr('video-url');

		let player = new videojs('banner-video');
		player.on('ready', function() {
			player.play();
		})
		player.src({type: 'video/youtube', src: src});
		player.on('play', function() {
			$videoWrapper.addClass('_playing');
		})
		player.on('pause', function() {
			$videoWrapper.removeClass('_playing');
		});

		player.on('ended', function() {
			$videoWrapper.removeClass('_playing');
		});

		$playBtn.click(function() {
			player.paused() && player.play();
		})
	}
	BannerVideo();


	
}


// WEBPACK FOOTER //
// ./src/js/home.js